import React, { useCallback, useState } from "react";

import { useHistory } from "react-router-dom";

import { ClientSearchFiltersCheckboxLabel } from "../Clients/types";
import ButtonPrimary from "@src/multiCustodian/components/MUI/Button/Button";
import { CheckboxListConfig } from "@src/sharedComponents/ScrollableCheckboxList/ScrollableCheckboxList";
import SegmentedButton from "@src/sharedComponents/SegmentedButton/SegmentedButton";
import useResetTablePaginationPage from "@src/sharedComponents/Table/useResetTablePaginationPage";

import { ClientType } from "./constants";
import CreateHouseholdsModal from "./CreateHousehold/CreateHouseholdsModal";
import { SearchInput } from "./SearchInput";

import * as styles from "./Households.module.css";

export default function HouseholdsHeader({
  search,
  searchFilters,
  setSearch,
  setSearchFilters,
  currentView,
  setCurrentView,
}: {
  search: string;
  searchFilters: CheckboxListConfig<ClientSearchFiltersCheckboxLabel>;
  setSearch: (search: string) => void;
  setSearchFilters: (
    filters: CheckboxListConfig<ClientSearchFiltersCheckboxLabel>
  ) => void;
  currentView: ClientType;
  setCurrentView: (view: ClientType) => void;
}) {
  const history = useHistory();
  const resetTablePaginationPage = useResetTablePaginationPage();
  const [toggleCreateHousehold, setToggleCreateHousehold] = useState(false);

  const openCreateClient = useCallback(() => {
    const location = history.location;
    history.push({ ...location, pathname: "/Advisor/Clients/Create" });
  }, [history]);

  const toggleClientType = (view: ClientType) => {
    setCurrentView(view);
    resetTablePaginationPage();
  };

  const toggleCreateHouseholdModal = () => {
    setToggleCreateHousehold(!toggleCreateHousehold);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <SearchInput
            search={search}
            setSearch={setSearch}
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
            currentView={currentView}
          />
        </div>

        {currentView === ClientType.CLIENT ? (
          <ButtonPrimary
            text="Create Client"
            onClick={openCreateClient}
            variant="contained"
            buttonType="primary"
            sx={{ height: "32px" }}
          />
        ) : (
          <ButtonPrimary
            text="Create Household"
            onClick={toggleCreateHouseholdModal}
            variant="contained"
            buttonType="primary"
            sx={{ height: "32px" }}
          />
        )}
      </div>

      <div className={styles.segmentedButtonContainer}>
        <SegmentedButton
          selected={currentView}
          options={[
            {
              key: ClientType.CLIENT,
              text: "Clients",
              action: () => toggleClientType(ClientType.CLIENT),
            },
            {
              key: ClientType.HOUSEHOLD,
              text: "Households",
              action: () => toggleClientType(ClientType.HOUSEHOLD),
            },
          ]}
        />
      </div>

      <CreateHouseholdsModal
        isOpen={toggleCreateHousehold}
        closeModal={() => setToggleCreateHousehold(false)}
      />
    </>
  );
}
